import { post, get } from "./http"

const mobilePeng = {

    // 上传撞库文件
    uploadMobilePeng(params){
        return post('mobilepeng/add',params)
    },

    //查看撞库任务记录
    getList(params){
        return get('mobilepeng/list',params)
    },
    //导出txt
    export(params){
        return post('mobilepeng/export',params)
    },
    //查看模板列表
    showTemplateList(){
        return get('mobilepeng/templateList')
    },
    // 5G撞库
    uploadMobile5g(params){
        return post('mobilepeng/upload5gFile',params)
    },
    // 5G撞库记录
    get5gList(params){
        return get('mobilepeng/5gMobileVerifyList',params)
    }

}

export default mobilePeng
